import { lazy } from "react";
// data
import data from "src/config/search.json";
// pages
const RoutingPage = lazy(() => import("src/pages/routing/routing"));
const ServiceAreaPage = lazy(() => import("src/pages/routing/service-area"));

const keys = Object.keys(data.services);
const currentkey = keys[4];

export const RoutingRoutes = [
  {
    path: currentkey,
    children: [
      { path: data.services.Routing[0].url, element: <ServiceAreaPage /> },
      { path: data.services.Routing[1].url, element: <RoutingPage /> },
    ],
  },
];
